import React from "react";
import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";

const switchStyleProps = new Set([
    "checkedBorderColor",
    "checkedThumbColor",
    "checkedTrackColor",
    "checkedTranslateX",
    "focusColor",
    "switchHeight",
    "switchMargin",
    "switchMarginBottom",
    "switchMarginTop",
    "switchPadding",
    "switchWidth",
    "thumbBackgroundColor",
    "thumbBorderColor",
    "thumbSize",
    "trackBackgroundColor",
    "trackBorderColor",
    "trackHeight",
    "trackRadius",
]);

const BaseStyledSwitch = styled(Switch, {
    shouldForwardProp: (prop) => !switchStyleProps.has(prop),
})(({
    checkedBorderColor,
    checkedThumbColor,
    checkedTrackColor,
    checkedTranslateX = 16,
    focusColor,
    switchHeight = 22,
    switchMargin,
    switchMarginBottom,
    switchMarginTop,
    switchPadding = 0,
    switchWidth = 37,
    theme,
    thumbBackgroundColor,
    thumbBorderColor,
    thumbSize = 18,
    trackBackgroundColor,
    trackBorderColor,
    trackHeight,
    trackRadius,
}) => {
    const resolvedCheckedTrackColor = checkedTrackColor || "#1A61FF";
    const resolvedTrackBorderColor = trackBorderColor || theme.palette.grey[400];
    const resolvedCheckedBorderColor = checkedBorderColor || resolvedCheckedTrackColor;

    return {
        width: switchWidth,
        height: switchHeight,
        padding: switchPadding,
        margin: switchMargin,
        marginTop: switchMarginTop,
        marginBottom: switchMarginBottom,
        "& .MuiSwitch-switchBase": {
            padding: 1,
            "&.Mui-checked": {
                transform: `translateX(${checkedTranslateX}px)`,
                color: checkedThumbColor || theme.palette.common.white,
                "& + .MuiSwitch-track": {
                    backgroundColor: resolvedCheckedTrackColor,
                    opacity: 1,
                    border: resolvedCheckedBorderColor === "none" ? "none" : `1px solid ${resolvedCheckedBorderColor}`,
                },
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
                color: focusColor || resolvedCheckedTrackColor,
                border: "6px solid #fff",
            },
        },
        "& .MuiSwitch-thumb": {
            width: thumbSize,
            height: thumbSize,
            border: thumbBorderColor ? `1px solid ${thumbBorderColor}` : undefined,
            backgroundColor: thumbBackgroundColor,
        },
        "& .MuiSwitch-track": {
            borderRadius: trackRadius || switchHeight / 2,
            border: resolvedTrackBorderColor === "none" ? "none" : `1px solid ${resolvedTrackBorderColor}`,
            backgroundColor: trackBackgroundColor || theme.palette.grey[50],
            height: trackHeight,
            opacity: 1,
            transition: theme.transitions.create(["background-color", "border"]),
        },
    };
});

export default function StyledSwitch({ disableRipple = true, ...props }) {
    return <BaseStyledSwitch disableRipple={disableRipple} {...props} />;
}
